import React from 'react';
import { Helmet } from 'react-helmet';

interface MetaProps {
  title?: string;
  urlSite?: string;
  desc?: string;
  ogType?: string;
  ogTitle?: string;
  ogDesc?: string;
  ogImg?: string;
  ogUrl?: string;
  ogSiteName?: string;
  keywords?: string;
}

const MetaHelmet = ({
  title = 'Decentralized Universe Meta - Mythic Protocol'
}: MetaProps) => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{title}</title>
      </Helmet>
    </>
  );
};

export default MetaHelmet;
